<template>
  <div class="card card-register">
    <div class="card__body">
      <div class="logo">
        <nuxt-link :to="isRoleApplication ? '/lp/create' : '/'">
          <img v-if="isRoleApplication" class="lp" src="/img/lp-create/create-logo.svg" width="250" height="43" alt="" />
          <img v-else src="/frontend/img/logo-c.svg" width="250" height="76" alt="" />
        </nuxt-link>
      </div>
      <div class="card_form_content center-form">
        <div class="form">
          <div v-if="isSuccess && isAlert" class="alert alert-success">
            {{ message }}
          </div>
          <div v-if="!isSuccess && isAlert" class="alert alert-danger">
            {{ message }}
            <div v-if="resendMail">
              <a href="" @click.prevent="resend" :disabled="retryAfter > 0">{{ $t('buttons.resend') }}</a>
              <span v-if="retryAfter > 0">({{ retryAfter }})</span>
            </div>
          </div>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(doLogin)" class="auth__register__section" autocomplete="off">
              <div class="group-register-input">
                <validation-provider name="メールアドレス" rules="required|email|max:128" v-slot="{ errors }">
                  <p class="auth__register__label mt60">メールアドレス</p>
                  <input type="text" class="input__text" name="email" v-model="email" :class="errors[0] ? 'is-invalid' : 'mb16'" />
                  <invalid-feedback class="mb16" :errors="errors" />
                </validation-provider>
              </div>
              <div class="group-register-input">
                <validation-provider name="パスワード" rules="required|max:128" v-slot="{ errors }">
                  <p class="auth__register__label">パスワード</p>
                  <input type="password" class="input__text" name="password" v-model="password" :class="errors[0] ? 'is-invalid' : 'mb16'" />
                  <invalid-feedback class="mb16" :errors="errors" />
                </validation-provider>
              </div>
              <div slot="footer" class="mb40">
                <button class="auth__login__button button button--big button--primary mb40 mt32" type="submit" :disabled="btnLoading">
                  <BSpinner v-if="btnLoading" class="mr-1" />
                  ログインする
                </button>
                <div class="auth__links">
                  <nuxt-link v-if="isRoleApplication" to="/auth/register-application" class="mb12">新規会員登録はこちら</nuxt-link>
                  <nuxt-link v-else to="/auth/register" class="mb12">新規会員登録はこちら</nuxt-link>
                  <br />
                  <nuxt-link v-if="isRoleApplication" to="/auth/forgot-password-application">パスワードをお忘れの方はこちら</nuxt-link>
                  <nuxt-link v-else to="/auth/forgot-password">パスワードをお忘れの方はこちら</nuxt-link>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InvalidFeedback from '@/components/particles/InvalidFeedback'
import BSpinner from '@/components/particles/BSpinner'

export default {
  components: { BSpinner, InvalidFeedback },
  data: () => ({
    email: '',
    password: '',
    retryAfter: null,
    deviceToken: null,
  }),
  computed: {
    ...mapState({
      isSuccess: state => state.frontend.auth.login.isSuccess,
      message: state => state.frontend.auth.login.message,
      isAlert: state => state.frontend.auth.login.isAlert,
      resendMail: state => state.frontend.auth.login.resendMail,
      companies: state => state.frontend.auth.companies,
      btnLoading: rootState => rootState.btnLoading,
    }),
  },
  props: {
    isRoleApplication: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    const messaging = this.$fire.messaging
    if (messaging) {
      messaging
        .getToken()
        .then(token => (this.deviceToken = token))
        .catch(console.log)
    }
  },
  methods: {
    ...mapActions({
      login: 'frontend/auth/login',
      resendVerifyMail: 'frontend/auth/resendVerifyMail',
    }),

    async doLogin() {
      let email, password, deviceToken
      email = this.email
      password = this.password
      deviceToken = this.deviceToken

      const redirect = this.$route.query?.redirect || '/dashboard'

      const { data } = await this.login({ email, password, deviceToken })

      if (this.companies.length == 0 && this.isSuccess) {
        return
      }
      if (!this.isSuccess && data?.register) {
        this.$store.commit('frontend/auth/setRegisterEmail', email)
        return this.$router.push(
          this.isRoleApplication ? `/auth/register-application` : `/auth/register`
        )
      }

      if (this.isSuccess) {
        this.$gtm.push({ event: 'login' })
        this.$store.commit('frontend/auth/setAlert', false)
        return this.$router.push(redirect)
      }
    },
    async resend() {
      if (this.retryAfter > 0) {
        return false
      }

      const { errResponse, data: responseData } = await this.resendVerifyMail({ email: this.email })

      this.retryAfter = responseData?.data?.retryAfter || 60

      this.countDownTimer()

      if (!errResponse && responseData.success) {
        return this.$notify.success({ title: responseData.message })
      }
    },
    countDownTimer() {
      if (this.retryAfter <= 0) {
        return false
      }

      this.retryAfter += -1
      setTimeout(() => this.countDownTimer(), 1000)
    },
  },
}
</script>

<style scoped lang="scss">
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  &.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  &.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
}
</style>
